import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=4536a694&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4536a694",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4536a694')) {
      api.createRecord('4536a694', component.options)
    } else {
      api.reload('4536a694', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=4536a694&scoped=true&", function () {
      api.rerender('4536a694', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/nyukin/detail.vue"
export default component.exports